import departmentsReducer from "./reducers";
export { default as departmentsTypes } from "./types";
export { default as departmentsOperations } from "./operations";
export default departmentsReducer;
